import MainLayout from '@/layout/MainLayout';
import CenterLayout from '@/layout/centerLayout/CenterLayout';
import pageProps from '@/layout/pageProps';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

function NewsCenter() {
  const router = useRouter();

  useEffect(() => {
    setTimeout(() => {
      router.replace('/news/announcement');
    }, 100);
  }, []);

  return (
    <MainLayout>
      <CenterLayout>
        {() => {}}
      </CenterLayout>
    </MainLayout>
  );
}

export async function getStaticProps(props) {
  const defaultProps = await pageProps(props);
  return { props: defaultProps };
}

export default NewsCenter;
